<template>
    <div>
    <v-dialog transition="fab-transition" content-class="login_dialog" width="400" style="background:transparent;" @keydown.enter="login" @keydown.esc="$store.state.APP.SHOW_LOGIN=false" v-model="$store.state.APP.SHOW_LOGIN">

        <v-card  :loading="isLoading" class="mx-auto">
         <v-card-title class="text-center">
             <v-spacer></v-spacer>
             <h3 class="text-center">Logga in</h3>
             <v-spacer></v-spacer>

         </v-card-title>
         <v-card-text>
             <v-form error>
                 <v-text-field
                         prepend-icon="mdi-account-circle"
                         label="Användarnamn"
                         v-model="username"
                         :rules="rules.username"
                         :error-messages="incorrectInfo ? ['Felaktigt lösenord eller användarnamn']:[]"

                 />
                 <v-text-field

                         prepend-icon="mdi-lock"
                         :append-icon="showPassword ? 'mdi-eye' :'mdi-eye-off'"
                         label="Lösenord"
                         :type="showPassword ? 'text' :'password'"
                         @click:append="showPassword=!showPassword"
                         hint=""
                         v-model="password"
                         :rules="rules.password"

                 />

                 <v-row no-gutters>
                        <v-spacer></v-spacer>
                         <v-btn class="mt-4 font-weight-light text-capitalize" @click="$store.state.APP.SHOW_LOGIN=false;forgot_model=true" style="color:#757575" small text>
                             Glömt lösenord?
                         </v-btn>
                     <v-spacer></v-spacer>

                 </v-row>



             </v-form>
         </v-card-text>
         <v-divider></v-divider>


         <v-card-actions>
             <v-btn class="mx-auto" small text @click="create_account" >Skapa konto</v-btn>

             <v-spacer></v-spacer>
             <v-btn @click="login" dark :disabled="loginDisabled" style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" class="teal">Logga in</v-btn>
         </v-card-actions>

     </v-card>

        <v-card  style="max-width:200px;" class="my-12 mx-auto">
            <v-card-title style="height: 24px;" class="py-0">
                <v-spacer></v-spacer>
                <v-subheader style="text-align: center;">Logga in genom</v-subheader>
                <v-spacer></v-spacer>

            </v-card-title>



            <v-card-actions>
                <v-btn style="margin-top:0;" text class="mx-auto deep-purple--text"  :loading="twitch_loading" @click="go_to_twitch" >
                    <v-icon>mdi-twitch</v-icon>
                    Twitch</v-btn>








            </v-card-actions>

        </v-card>






    </v-dialog>
        <v-dialog transition="fab-transition" content-class="login_dialog" width="400" style="background:transparent;" @keydown.enter="forgot" @keydown.esc="forgot_model=false" v-model="forgot_model">

            <v-card  class="mx-auto">
                <v-card-title class="text-center">
                    <v-spacer></v-spacer>
                    <h3 class="text-center">Glömt Lösenord</h3>
                    <v-spacer></v-spacer>

                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-form error>
                        <v-text-field
                                prepend-icon="mdi-email"
                                label="Email"
                                v-model="forgotten_email"


                        />






                    </v-form>
                    Ett mail skickas till angiven adress med instruktioner för att återställa ditt lösenord.
                </v-card-text>
                <v-divider></v-divider>


                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn @click="forgot" dark :disabled="forgotDisabled" style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" class="teal">Återställ</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>

            </v-card>








        </v-dialog>

        <v-dialog transition="fab-transition" content-class="login_dialog" width="400" style="background:transparent;" @keydown.enter="reset_password" @keydown.esc="$store.state.APP.SHOW_NEW_PASSWORD=false" v-model="$store.state.APP.SHOW_NEW_PASSWORD">

            <v-card  class="mx-auto">
                <v-card-title class="text-center">
                    <v-spacer></v-spacer>
                    <h3 class="text-center">Nytt Lösenord</h3>
                    <v-spacer></v-spacer>

                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-form error>
                        <v-text-field
                                v-model="new_password"

                                :rules="rules.new_password"
                                :type="new_password_show ? 'text' : 'password'"
                                label="Lösenord"
                        >
                            <template v-slot:append>
                                <v-btn tabindex="-1" @click="new_password_show = !new_password_show" icon>
                                    <v-icon>{{new_password_show ? 'mdi-eye' : 'mdi-eye-off'}}</v-icon>
                                </v-btn>
                            </template>

                        </v-text-field>


                            <v-text-field
                                    v-model="new_password_repeat"
                                    :rules="[passwordConfirmationRule]"
                                    :type="new_password_show_repeat ? 'text' : 'password'"
                                    label="Repetera lösenord"
                            >
                                <template v-slot:append>
                                    <v-btn tabindex="-1" @click="new_password_show_repeat = !new_password_show_repeat" icon>
                                        <v-icon>{{new_password_show_repeat ? 'mdi-eye' : 'mdi-eye-off'}}</v-icon>
                                    </v-btn>
                                </template>

                            </v-text-field>






                    </v-form>
                </v-card-text>
                <v-divider></v-divider>


                <v-card-actions>

                    <v-spacer></v-spacer>
                    <v-btn @click="reset_password" dark :disabled="newPasswordDisabled" style="background: linear-gradient(40deg, rgb(106, 187, 187) 0%, rgb(47, 218, 158) 100%);" class="teal">Sätt nytt</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>

            </v-card>








        </v-dialog>
        <CreateAccount></CreateAccount>

        <v-snackbar
            v-model="snackbar"
    >
        Välkommen {{this.$store.state.STREAMER.USER_NAME}}
        <v-btn
                color="pink"
                text
                @click="snackbar = false"
        >
            Stäng
        </v-btn>
    </v-snackbar>
</div>
</template>

<script>
    import CreateAccount from "./CreateAccount";
    export default {
        name: "Login",
        components:{CreateAccount},
        data(){
            return{
                new_name_taken:false,
                new_email_taken:false,
                el1_button_loading:false,
                new_account_valid:false,
                e1: 2,
                showPassword:false,
                new_password_show:false,
                new_password_show_repeat:false,
                incorrectInfo:false,
                username:"",
                new_username:"",
                new_email:"",
                new_password:"",
                new_password_repeat:"",
                password:"",
                isLoading:false,
                snackbar:false,
                twitch_loading:false,
                rules: {
                    username: [value => value.length > 2 || 'Ange ditt användarnamn'],
                    password: [value => value.length > 2 || 'Ange ditt lösenord'],
                    new_username: [
                        v => !!v || 'Ange ett användarnamn.',
                        v => v.length >= 3 || 'Användarnamnet är för kort',
                    ],
                    new_email: [
                        v => !!v || 'Ange en giltig mailadress',
                        v => /.+@.+/.test(v) || 'Ange en giltig mailadress',
                    ],
                    new_password: [value => value.length > 3 || 'Ange ett lösenord']



                },
                forgot_model:false,
                forgotten_email:""
            }
        },
        computed:{
            loginDisabled:function(){
                return !(this.username.length>2 && this.password.length>2)
            },
            forgotDisabled:function(){
                return !(this.forgotten_email.length>2)
            },
            passwordConfirmationRule() {
                return (this.new_password === this.new_password_repeat) || 'Lösenorden matchar inte'
            }
            ,
            new_name_taken_f() {
                return (!this.new_name_taken) || 'Användarnamnet är upptaget'
            }
            ,
            new_email_taken_f() {
                return (!this.new_email_taken) || 'Email-adressen är upptagen'
            },
            newPasswordDisabled(){
              return   !(this.new_password===this.new_password_repeat && this.new_password.length>3)
            }

        },

        methods:{


            forgot:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;

                let url = '/api/reset?';
                let params = 'email='+this.forgotten_email;
                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.
                    if(http.readyState === 4 && http.status >= 400) {
                        self.$store.commit("update_snackbar","Ett mail med instruktioner har skickats till "+self.forgotten_email);
                        self.forgot_model=false;


                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("update_snackbar","Ett mail med instruktioner har skickats till "+self.forgotten_email);
                        self.forgot_model=false;
                    }
                };
                http.send(params);
            },

            reset_password:function(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let identifier=this.$route.query.reset;
                let url = '/api/resetPassword?';
                let params = 'password='+this.new_password+'&identifier='+identifier;
                http.open('POST', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.onreadystatechange = function() {//Call a function when the state changes.


                    if(http.readyState === 4 && http.status === 400) {

                        self.$store.commit("update_snackbar","Ett fel inträffade. Hör av dig till oss.");
                        self.$store.state.APP.SHOW_NEW_PASSWORD=false;
                        window.history.replaceState(null, null, window.location.pathname);



                    }
                    else if(http.readyState === 4 && http.status === 200){
                        self.$store.commit("update_snackbar","Lösenordet har ändrats");
                        self.$store.state.APP.SHOW_NEW_PASSWORD=false;
                        window.history.replaceState(null, null, window.location.pathname);


                    }
                };
                http.send(params);
            },

            create_account:function(){
                this.$store.state.APP.SHOW_LOGIN=false;
                this.$store.state.APP.SHOW_CREATE=true;
                this.$store.state.APP.CREATE_PAGE=1;
            },

            go_to_twitch:function(){
                this.twitch_loading=true;
                this.$cookies.set("go_to",window.location.pathname.substr(1));
                window.location.href="/api/auth/twitch";
            },

            login: function () {
                this.isLoading="teal";
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/login?';
                let params = 'username='+this.username+"&password="+this.password;
                http.open('POST', url, true);
                let self=this;
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                http.onreadystatechange = function() {//Call a function when the state changes.

                    if(http.readyState === 4 && http.status > 200) {
                        self.isLoading=false;
                        self.incorrectInfo=true;


                    }
                    else if(http.readyState === 4 && http.status === 200){
                        console.log(http.responseText);
                        self.isLoading=false;
                        self.incorrectInfo=false;
                        self.$store.state.APP.SHOW_LOGIN=false;
                        self.$store.dispatch("get_settings_data");
                        self.$store.dispatch("get_hicards_data");
                        self.snackbar=true
                        if(self.$store.state.APP.LOGIN_CALLBACK !==null){
                          self.$store.state.APP.LOGIN_CALLBACK();
                          self.$store.state.APP.LOGIN_CALLBACK=null;
                        }


                    }
                };
                return http.send(params);
            }
        },
        watch:{
            new_email:function(){
                this.new_email_taken=false;
            },
            new_username:function(){
                this.new_name_taken=false;

            }
        }
    }
</script>

<style >
    .login_dialog{
        box-shadow: none !important;
    }
    .v-input__icon--append > button{
        outline:0;
        tab-index: -1;
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active  {
        -webkit-box-shadow: 0 0 0 30px white inset !important;
    }


</style>
